module.exports = __webpack_public_path__ + "img/shiyanshianquanCode.7e10936f.jpg";